<script lang="ts" setup>
import { useFooter } from '@composables/hooks/molecules/footer/footer.hook'

import TextQuaternary from '@UI/Typography/TextQuaternary.vue'

defineOptions({
  name: 'FooterCopyright',
})

const { currentYear } = useFooter()

</script>

<template>
  <TextQuaternary class="footer-copyright">
    © Brighterly {{ currentYear }}
  </TextQuaternary>
</template>

<style scoped lang="scss" src="@scss/components/Molecules/Footer/FooterCopyright.scss" />